import { Navigate, Outlet } from "react-router-dom";

import { useIsSuperAdmin } from "@/api/is-superadmin";
import { LoadingScreen } from "@/components/loading-screen";

export function SuperAdminGuard() {
  const { isSuperAdmin, isLoading } = useIsSuperAdmin();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isSuperAdmin) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
}
